import {create} from 'zustand';
import {ChangeDataAlertStore} from './types';
import {DEFAULT_ALERT_STORE} from './constants';

export const useChangeDataAlertStore = create<ChangeDataAlertStore>(set => ({
	status: DEFAULT_ALERT_STORE,
	setStatus: status => set({status}),
	reset: () => set({status: DEFAULT_ALERT_STORE}),
}));
